module.exports = __webpack_public_path__ + "static/images/drivingPermitExample-4.d6f4267.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/drivingPermitExample-4.png
// module id = rER3
// module chunks = 0